export default __webpack_public_path__ + "static/app-icon-02c032e9968a8f2275308c153bfb3b63.png";